import { z } from "zod";

export const MyAccountSchema = {
  personalSettings: z.object({
    firstName: z.string().min(3, {
      message: 'First Name must be at least 3 characters.'
    }),
    lastName: z.string().min(3, {
      message: 'Last Name must be at least 3 characters.'
    }),
    timezone: z.string().optional()
  }),
  accountSettings: z.object({
    email: z.string().email(),
    password: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    }),
    newPassword: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    }),
    confirmNewPassword: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    })
  })
}
